<template>
    <div id="monitorization-wrapper">
        <div class="monitorization-spinner" v-if="isLoading">
            <SpeenComponent
                :isAutomatic="true"
                :ringWidth="14"
                :spinnerSize="15"
                :isverticalAligned="true"
            ></SpeenComponent>
        </div>
        <div class="production-lines-list container" v-for="productionLine in productionLines" :key="productionLine.id" >
            <div class="production-line-monitorizacion">
                <ProductionLine
                    :ref="`production-line-${productionLine.id}`"
                    :productionLine="productionLine"
                ></ProductionLine>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';

    import ProductionLine from "../components/ProductionLine";
    import SpeenComponent from "../../common/components/SpeenComponent";

    import { mapGetters, mapActions } from 'vuex';
    import { showCustomErrorSweetAlert } from "../../common/utils";

    export default {
        name: "MonitorizationComponent",
        components: {
            ProductionLine,
            SpeenComponent
        },
        data(){
            return{}
        },
        computed:{
            ...mapGetters(['productionLines']),
            ...mapGetters('monitorization', ['productionLinesCollapseStates']),
            isLoading(){
                return !(this.productionLines && this.productionLines.length > 0);
            }
        },
        methods:{
            ...mapActions(['createProductionLine']),
            ...mapActions('monitorization', ['createProductionLineCollapseState'])
        },
        mounted() {
            var self = this;

            axios
            .get(`/api/production-line/monitorization-structure`)
            .then( res => {
                if(res.hasOwnProperty('data')){
                    res.data.forEach(function (productionLine, i) {
                        self.createProductionLine({
                            productionLine: productionLine
                        })
                        self.createProductionLineCollapseState({id: productionLine.id, state: false})
                    })
                }else{
                    //ERROR AL OBTENER INFORMACION DE LAS LINEAS
                }
            })
            .catch( error => {
                console.log(err)
                showCustomErrorSweetAlert(error.response.data)
            })
        }

    }
</script>
